import { useSelector } from 'react-redux';
import { portalAccess } from '../services/PortalAccess';

export const usePortalAccess = () => useSelector((state) => {
  const { user, isLoading, isInitialLoading, sessionVersion = 0 } = state.user;
  const access = portalAccess(isLoading || isInitialLoading ? null : user);
  return { ...access, sessionVersion };
});
